<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="'pages.payments.detail' | translate"
    [isForm]="true"
    (onBack)="onClose()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <div class="row">
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <!-- id -->
        <list-group-item
          [label]="'common.id' | translate"
          [value]="model?.id | checkValue"
        >
        </list-group-item>
      </div>

      <!-- amount -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="'common.amount' | translate"
          [value]="model?.amount | numberSeparator | checkValue"
          [hasCurrency]="true"
        >
          <i
            icon
            class="mdi mdi-cash tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>
      <!-- typePayment -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'typePayment' | translate"
          [isShowValue]="false"
        >
          <span
            class="badge badge-light border tw-text-gray-800 tw-text-[13px] dir-ltr"
            copyToClipboard
            content
          >
            <span [paymentTypeStyle]="model?.typePayment">
              {{ model?.typePayment | enumToText : TypePaymentsEnumValues }}
            </span>
          </span>
        </list-group-item>
      </div>

      <!-- typeStatus -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'typeStatus' | translate"
          [isShowValue]="false"
        >
          <div
            class="badge badge-light border tw-text-gray-800 tw-text-[13px] dir-ltr"
            copyToClipboard
            content
          >
            <span [paymentStatusStyle]="model?.typeStatus">
              <span>
                {{
                  model?.typeStatus | enumToText : TypePaymentStatusEnumValues
                }}
              </span>
            </span>
          </div>
        </list-group-item>
      </div>

      <!-- billNumber -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'billNumber' | translate"
          [value]="model?.billNumber | checkValue"
        >
        </list-group-item>
      </div>

      <!-- paymentDate -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'paymentDate' | translate"
          [isShowValue]="false"
        >
          <div
            class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
            content
          >
            <span class="dir-ltr">
              {{
                model?.paymentDate
                  | dateTimeConvertor : translationService.currentLang() || "-"
              }}
            </span>
          </div>
          <i
            icon
            class="mdi mdi-calendar-clock tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- col 2  -->

      <!-- accountInformationBank -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'accountInformationBank' | translate"
          [isShowValue]="false"
        >
          <span
            class="badge badge-light border tw-text-gray-800 tw-text-[13px] dir-ltr"
            copyToClipboard
            content
          >
            {{
              model?.accountInformationBank | enumToText : TypeBanksEnumValues
            }}
          </span>

          <i
            icon
            class="mdi mdi-bank tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- accountInformationAccountNo -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'accountInformationAccountNo' | translate"
          [value]="model?.accountInformationAccountNo | checkValue"
        >
          <i
            icon
            class="mdi mdi-credit-card-outline tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- accountInformationCardNo -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'accountInformationCardNo' | translate"
          [value]="model?.accountInformationCardNo | checkValue"
        >
          <i
            icon
            class="mdi mdi-credit-card-outline tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- accountInformationId -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'accountInformationId' | translate"
          [value]="model?.accountInformationId | checkValue"
        >
        </list-group-item>
      </div>
      <!-- accountInformationOwner -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'accountInformationOwner' | translate"
          [value]="model?.accountInformationOwner | checkValue"
        >
          <i
            icon
            class="mdi mdi-account tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- isOnlineGeneral -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'isOnlineGeneral' | translate"
          [isShowValue]="false"
        >
          <div
            class="badge badge-light border tw-text-gray-800 tw-text-[13px] dir-ltr"
            content
          >
            <td-value
              type="boolean"
              [value]="model?.isOnlineGeneral"
            ></td-value>
          </div>
        </list-group-item>
      </div>

      <!-- col 3  -->

      <!-- userFirstLastName -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'userFirstLastName' | translate"
          [value]="model?.userFirstLastName | checkValue"
        >
          <i
            icon
            class="mdi mdi-account tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- userName -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="'common.userName' | translate"
          [value]="model?.userName | checkValue"
        >
          <i
            icon
            class="mdi mdi-account tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- createdBy -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'createdBy' | translate"
          [value]="model?.createdBy | checkValue"
        >
        </list-group-item>
      </div>

      <!-- created -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="'common.createDate' | translate"
          [isShowValue]="false"
        >
          <div
            class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
            content
          >
            <span class="dir-ltr">
              {{
                model.created
                  | dateTimeWithSecondConvertor
                    : translationService.currentLang() || "-"
              }}
            </span>
          </div>
          <i
            icon
            class="mdi mdi-calendar-clock tw-text-gray-700 dark:tw-text-gray-200 tw-ml-2 tw-mb-2 mdi-20px"
          ></i>
        </list-group-item>
      </div>

      <!-- userName -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'userName' | translate"
          [value]="model?.userName | checkValue"
        >
        </list-group-item>
      </div>

      <!-- payerOrganizationName -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'payerOrganizationName' | translate"
          [value]="model?.payerOrganizationName | checkValue"
        >
        </list-group-item>
      </div>

      <!-- col 4  -->
      <!-- *ngIf="permissionService.userState()?.isSuperAdmin || permissionService.userState()?.isAdmin" -->

      <!-- adminResellerCode -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'adminResellerCode' | translate"
          [value]="model?.adminResellerCode | checkValue"
        >
        </list-group-item>
      </div>

      <!-- domainId -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="'common.domainId' | translate"
          [value]="model?.domainId | checkValue"
        >
        </list-group-item>
      </div>

      <!-- domainName -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="'common.domainName' | translate"
          [value]="model?.domainName | checkValue"
        >
        </list-group-item>
      </div>

      <!-- resellerCode -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'resellerCode' | translate"
          [value]="model?.resellerCode | checkValue"
        >
        </list-group-item>
      </div>

      <!-- receiverOrganizationName -->
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <list-group-item
          [label]="fields + 'receiverOrganizationName' | translate"
          [value]="model?.receiverOrganizationName | checkValue"
        >
        </list-group-item>
      </div>
    </div>

    <div class="row">
      <div class="sm:tw-w-1/2 xl:tw-w-1/3">
        <!-- description -->
        <div
          class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-300 tw-rounded-md tw-flex tw-justify-start flex-column tw-py-4 tw-my-2 sms-text border-top"
        >
          <div
            class="tw-flex tw-justify-start tw-items-center border-bottom dark:tw-border-dark-100 tw-text-gray-700 dark:tw-text-gray-100 tw-pb-2"
          >
            <i class="mdi mdi-information-outline tw-ml-2 tw-mb-1 mdi-20px"></i>
            <span class="tw-font-medium"
              >{{ "common.description" | translate }}
            </span>
          </div>
          <div
            class="tw-pt-5 tw-text-gray-600 dark:tw-text-gray-200"
            copyToClipboard
          >
            {{ model?.description }}
          </div>
        </div>
      </div>

      <div
        *ngIf="model?.typePayment == TypePayments.Cheque"
        class="sm:tw-w-1/2 xl:tw-w-1/3 tw-rounded-md"
      >
        <!-- chequeImageAddress -->
        <li
          class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-300 tw-rounded-md tw-flex flex-column tw-py-4 tw-my-2 cheque-img-container"
        >
          <span
            class="tw-font-medium tw-text-gray-600 dark:tw-text-gray-100 border-bottom tw-pb-2"
            >{{ fields + "chequeImageAddress" | translate }}</span
          >
          <app-show-images
            class="tw-mt-1 cheque-img"
            [src]="chequeImage"
          ></app-show-images>
        </li>
      </div>
    </div>
  </div>
</app-page-body>

